"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticFile = void 0;

var trimLeadingSlash = function trimLeadingSlash(path) {
  if (path.startsWith('/')) {
    return trimLeadingSlash(path.substr(1));
  }

  return path;
};

var inner = function inner(path) {
  if (typeof window !== 'undefined' && window.remotion_staticBase) {
    return "".concat(window.remotion_staticBase, "/").concat(trimLeadingSlash(path));
  }

  return "/".concat(trimLeadingSlash(path));
};

var staticFile = function staticFile(path) {
  if (path.startsWith('http://') || path.startsWith('https://')) {
    throw new TypeError("staticFile() does not support remote URLs - got \"".concat(path, "\". Instead, pass the URL without wrapping it in staticFile(). See: https://remotion.dev/docs/staticfile-remote-urls"));
  }

  if (path.startsWith('..') || path.startsWith('./')) {
    throw new TypeError("staticFile() does not support relative paths - got \"".concat(path, "\". Instead, pass the name of a file that is inside the public/ folder. See: https://remotion.dev/docs/staticfile-relative-paths"));
  }

  var preparsed = inner(path);

  if (!preparsed.startsWith('/')) {
    return "/".concat(preparsed);
  }

  return preparsed;
};

exports.staticFile = staticFile;